import { getLocalTranslation } from '../../utils/i18nKit';
export var getGenerateQuoteMethodMap = function getGenerateQuoteMethodMap() {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return {
    manual: {
      value: 'manual',
      label: $t('kit:generateQuoteMethod.fill_in_information_manually')
    },
    uploadFiles: {
      value: 'uploadFiles',
      label: $t('kit:generateQuoteMethod.upload_application_form')
    }
  };
};
export var getGenerateQuoteMethodList = function getGenerateQuoteMethodList() {
  return Object.values(getGenerateQuoteMethodMap());
};